import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const SettingsContext = createContext(null);
export const useSettings = () => useContext(SettingsContext);

const CACHE_KEY = "mtl_settings";
const readCache = () => {
  try { return JSON.parse(localStorage.getItem(CACHE_KEY)) || {}; } catch { return {}; }
};

export function SettingsProvider({ children }) {
  const cached = readCache();
  const [settings, setSettings] = useState(cached);
  // "loaded" is true immediately if we already have cached settings, so the UI
  // never shows a stock placeholder before real branding for returning visitors.
  const [loaded, setLoaded] = useState(Object.keys(cached).length > 0);

  const refresh = () => api.get("/settings")
    .then((r) => {
      setSettings(r.data);
      setLoaded(true);
      try { localStorage.setItem(CACHE_KEY, JSON.stringify(r.data)); } catch {}
    })
    .catch(() => setLoaded(true));

  useEffect(() => { refresh(); }, []);

  return (
    <SettingsContext.Provider value={{ settings, loaded, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}
